// ── What a document row says about itself ────────────────────────────────
//
// The technician portal lists estimates and invoices as rows. The big line
// used to be the service address, falling back to the trade — so Julian's
// first estimate for Olivia came up on his phone as the single word "Work",
// with the date and the document number under it. A list of jobs read as a
// list of reference codes.
//
// A technician scanning that screen is looking for a person, and then for
// what the job was. Those are the two lines.

import { localized } from './translated';

// Who the document is for. Only a real name: an invoice billed to QPS
// carries no customer, and putting "QPS" in the big type tells a technician
// nothing he did not already know.
export const docWho = (d) => (d?.customer?.name || '').trim();

// What the job is, in one line of small type under the name.
//
// The line items come first, because that is where the work is actually
// described: "FLOOR TILE · BASEBOARD" says more than the trade does, and a
// technician who typed "Work" in the trade box — they do — still gets a
// useful line. The address is last, because it is the only thing left worth
// reading when there are no items and no words.
export const docAbout = (d, words, lang) => {
  if (!d) return '';
  const items = (d.items || [])
    .map(i => (localized(i, 'name', lang) || localized(i, 'description', lang) || '').trim())
    .filter(Boolean);
  // Deduped: five lines all called "Labor" is not a description of anything.
  if (items.length) return [...new Set(items)].join(' · ');
  const trade = (words || '').trim();
  if (trade) return trade;
  const notes = (localized(d, 'notes', lang) || '').trim();
  if (notes) return notes;
  return (d.serviceAddress || '').trim();
};
